import {useMutation} from '@tanstack/react-query';
import AuthApi from '@/api/AuthApi';
import {ISignIn} from '@/api/interfaces';
import {showGeneralError} from '@/helper';

const useSignIn = () => {
    return useMutation({
        mutationFn: ({data}: ISignIn) => AuthApi.signIn({data}),
        onError: error => showGeneralError({error})
    });
};

export default useSignIn;
